export default function SocialLinksSection() {
    return (
        <div className="social-links text-center text-md-right pt-3 pt-md-0">
            <a href="https://www.facebook.com/constellationtraining/" className="facebook" target="_blank" rel="noopener noreferrer"><i className="bx bxl-facebook"></i></a>
            <a href="https://www.instagram.com/constellationtraining/" className="instagram" target="_blank" rel="noopener noreferrer"><i className="bx bxl-instagram"></i></a>
            <a href="https://www.linkedin.com/company/constellation-training" className="linkedin" target="_blank" rel="noopener noreferrer"><i className="bx bxl-linkedin"></i></a>
        </div>
    );
}